import React, { useEffect } from "react";
import DefaultInvoice from "./DefaultInvoice";
import Invoice1 from "./Invoice1";
import Invoice2 from "./Invoice2";
import Invoice3 from "./Invoice3";
import Invoice3WithVat from "./Invoice3WithVat";
import Invoice3WithTax from "./Invoice3WithTax";
import Invoice4 from "./Invoice4";
import KOT from "./KOT";
import { extractPrinterData } from "../../config/helperFunctions";

function InvoiceMain({ setting, invoiceDetails, handlePrint }) {
  const invoiceSetting = JSON.parse(
    setting.find((set) => set.type === "invoice_settings").value
  );
  const logo = JSON.parse(setting.find((set) => set.type === "logo").value);
  const general = JSON.parse(
    setting.find((set) => set.type === "general").value
  );
  const printerSettings = JSON.parse(
    setting.find((set) => set.type === "printer_settings").value
  );
  const currencySetting = JSON.parse(
    setting.find((set) => set.type === "currency").value
  );

  let InvoiceComponent;
  switch (invoiceSetting.invoice) {
    case "Default":
      InvoiceComponent = DefaultInvoice;
      break;
    case "Invoice 1":
      InvoiceComponent = Invoice1;
      break;
    case "Invoice 2":
      InvoiceComponent = Invoice2;
      break;
    case "Invoice 3":
      InvoiceComponent = Invoice3;
      break;
    case "Invoice 3 with VAT":
      InvoiceComponent = Invoice3WithVat;
      break;
    case "Invoice 3 with Tax":
      InvoiceComponent = Invoice3WithTax;
      break;
    case "Invoice 4":
      InvoiceComponent = Invoice4;
      break;
    default:
      InvoiceComponent = DefaultInvoice;
  }

  const printingType = printerSettings.printing_type;
  const multiKOTData = extractPrinterData(invoiceDetails, printingType);

  // Optional: handle any VAT logic
  let tobacoVat = 0;
  if (
    invoiceDetails.order_details?.some(
      (item) => item.food_menu.is_tax_fix === "yes"
    )
  ) {
    tobacoVat = invoiceDetails.order_details.reduce((acc, item) => {
      if (item.food_menu.is_tax_fix === "yes") {
        return acc + item.menu_taxes.additional_vat;
      }
      return acc;
    }, 0);
  }
  invoiceDetails.tobaco_vat = tobacoVat;

  useEffect(() => {
    handlePrint();
  }, [handlePrint]);

  return (
    <>
      {Array.from({ length: Number(invoiceSetting.no_of_invoices || 1) }).map(
        (_, index) => (
          <>
            <div className="invoice-page" key={index}>
              {" "}
              <InvoiceComponent
                logo={logo.logo_image_base64}
                general={general}
                data={invoiceDetails}
                invoice={invoiceSetting}
                currencySetting={currencySetting}
                handlePrint={handlePrint}
              />{" "}
            </div>{" "}
            {index < Number(invoiceSetting.no_of_invoices || 1) - 1 && (
              <div key={`${index}-pg`} className="page-break" />
            )}{" "}
          </>
        )
      )}

      {/* 🍽️ KOT Section */}
      {multiKOTData &&
        Object.keys(multiKOTData).map((key) => {
          const printerName = key;
          const data = multiKOTData[key];
          return (
            <div key={printerName} data-printer={printerName} className="invoice-page kot-page font-sans">
              <div className="page-break" />
              <KOT
                basicInfo={invoiceDetails}
                data={data}
                printer={printerName}
                handlePrint={handlePrint}
                invoice={invoiceSetting}
              />
            </div>
          );
        })}
    </>
  );
}

export default InvoiceMain;
